export const appMinusIcon = {
  data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <title>minus</title>
  <path d="M26.667 18.667h-21.333c-1.467 0-2.667-1.2-2.667-2.667s1.2-2.667 2.667-2.667h21.333c1.467 0 2.667 1.2 2.667 2.667s-1.2 2.667-2.667 2.667z"></path>
  </svg>
  `,
  name: 'minus'
};
